export const userData = [
  {
    name: 'Rahul Kaushik',
    tagline: 'Product Designer & Frontend Developer',
    desc: 'I design and develop products that create real value in people’s lives—focusing on solving practical problems, improving usability, and delivering meaningful experiences.',
    skills: ['System Design', 'React', 'TypeScript', 'MongoDB', 'Node.js'],
    likes: 128,
  },
]
